import { forwardRef } from 'react';
import { Button, ButtonProps } from 'reactstrap';

interface ToolbarIconButtonProps extends Pick<ButtonProps, 'icon' | 'onClick' | 'id' | 'disabled'> {
  isActive: boolean;
  caret?: boolean;
  testId?: string;
  title?: string;
}

export const ToolbarIconButton = forwardRef<HTMLButtonElement, ToolbarIconButtonProps>(
  ({ icon, onClick, isActive, id, caret, testId, disabled, title }, ref) => {
    const iconColor = isActive ? 'text-ThemeTextDark' : 'text-ThemeIconSecondary';
    return (
      <Button
        innerRef={ref}
        data-testid={testId}
        id={id}
        outline={false}
        color='transparent'
        onClick={onClick}
        disabled={disabled}
        className={`${isActive ? 'active' : ''} flex-shrink-0 border-0`}
        size='sm'
      >
        <i className={`fal ${icon} ${iconColor}`} />
        {title ? <span className='mx-1'>{title}</span> : null}
        {caret ? <i className={`ms-1 fal fa-caret-down ${iconColor}`} /> : null}
      </Button>
    );
  }
);

ToolbarIconButton.displayName = 'ToolbarIconButton';
